import transactionGroupSentData from './transaction-group-search-sent.json';

export default {
  sent: transactionGroupSentData,
};
